import { ref } from 'vue'
import { fetchCreditLedger } from '@/api/credits'
import type { CreditLedgerEntry, CreditLedgerType } from '@/types/newsletter'
import type { PaginationMeta } from '@/types/finance'

export function useCreditLedger(organisationId: number) {
  const entries = ref<CreditLedgerEntry[]>([])
  const loading = ref<boolean>(false)
  const error = ref<string | null>(null)
  const meta = ref<PaginationMeta | null>(null)
  const page = ref<number>(1)
  const perPage = ref<number>(25)

  async function fetch(typeFilter?: CreditLedgerType): Promise<void> {
    loading.value = true
    error.value = null
    try {
      const params: { type?: string; page?: number; per_page?: number } = {
        page: page.value,
        per_page: perPage.value,
      }
      if (typeFilter) params.type = typeFilter
      const result = await fetchCreditLedger(organisationId, params)
      entries.value = result.data
      meta.value = result.meta
    } catch {
      error.value = 'Failed to load credit history.'
    } finally {
      loading.value = false
    }
  }

  function setPage(newPage: number): void {
    page.value = newPage
  }

  function setPerPage(newPerPage: number): void {
    perPage.value = newPerPage
    page.value = 1
  }

  return { entries, loading, error, meta, page, perPage, fetch, setPage, setPerPage }
}
